import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const billing = createReducer(
  {
    list: [],
    isEmailSent: null,
    emailSentInvoiceId: null,
    isCardAdded: null,
    addCardError: {},
    info: {},
    cards: [],
    defaultCard: {},
    plans: [],
    planUpdateStatus: null,
    client: {},
  },
  {
    [types.GET_INVOICES_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.invoices.sort((a, b) => {
          return b.created_at - a.created_at;
        }),
      });

      return newState;
    },
    [types.GET_INVOICES_FAIL](state) {
      const newState = Object.assign({}, state, {
        list: [],
      });

      return newState;
    },
    [types.SEND_INVOICE_EMAIL_SUCCESS](state, action) {
      const newList = state.list.concat();

      for (let i = 0, l = newList.length; i < l; i += 1) {
        if (newList[i].invoiceid === action.invoiceId) {
          newList[i].isEmailSentSuccess = true;
          newList[i].isEmailSentFail = false;
          break;
        }
      }

      const newState = Object.assign({}, state, {
        list: newList,
      });

      return newState;
    },
    [types.SEND_INVOICE_EMAIL_FAIL](state, action) {
      const newList = state.list.concat();

      for (let i = 0, l = newList.length; i < l; i += 1) {
        if (newList[i].invoiceid === action.invoiceId) {
          newList[i].isEmailSentSuccess = false;
          newList[i].isEmailSentFail = true;
          break;
        }
      }

      const newState = Object.assign({}, state, {
        list: newList,
      });

      return newState;
    },
    [types.ADD_CARD_START](state) {
      return Object.assign({}, state, {
        isCardAdded: null,
      });
    },
    [types.ADD_CARD_SUCCESS](state) {
      return Object.assign({}, state, {
        isCardAdded: true,
      });
    },
    [types.ADD_CARD_FAIL](state, action) {
      return Object.assign({}, state, {
        isCardAdded: false,
        addCardError: action.error,
      });
    },
    [types.GET_BILLING_PLAN_START](state) {
      return Object.assign({}, state, {
        info: {},
      });
    },
    [types.GET_BILLING_PLAN_SUCCESS](state, action) {
      return Object.assign({}, state, {
        info: action.info,
      });
    },
    [types.GET_BILLING_PLAN_FAIL](state) {
      return Object.assign({}, state, {
        info: {},
      });
    },
    [types.GET_CARDS_SUCCESS](state, action) {
      return Object.assign({}, state, {
        cards: action.cards,
      });
    },
    [types.GET_CARDS_FAIL](state) {
      return Object.assign({}, state, {
        cards: [],
      });
    },
    [types.GET_DEFAULT_CARD_SUCCESS](state, action) {
      return Object.assign({}, state, {
        defaultCard: action.card,
      });
    },
    [types.GET_DEFAULT_CARD_FAIL](state) {
      return Object.assign({}, state, {
        defaultCard: {},
      });
    },
    [types.GET_AVAILABLE_PLANS_START](state) {
      return Object.assign({}, state, {
        plans: [],
      });
    },
    [types.GET_AVAILABLE_PLANS_SUCCESS](state, action) {
      return Object.assign({}, state, {
        plans: action.plans,
      });
    },
    [types.GET_AVAILABLE_PLANS_FAIL](state) {
      return Object.assign({}, state, {
        plans: [],
      });
    },
    [types.UPDATE_PLAN_START](state) {
      return Object.assign({}, state, {
        planUpdateStatus: null,
      });
    },
    [types.UPDATE_PLAN_SUCCESS](state, action) {
      return Object.assign({}, state, {
        planUpdateStatus: true,
        planUpdateMessage: action.message,
      });
    },
    [types.UPDATE_PLAN_FAIL](state) {
      return Object.assign({}, state, {
        planUpdateStatus: false,
        planUpdateMessage: 'Sorry, we are unable to switch your plan at this moment. Please try again later or contact support@truelark.com',
      });
    },
    [types.GET_CLIENT_SUCCESS](state, action) {
      return Object.assign({}, state, {
        client: action.client,
      });
    },
    [types.GET_CLIENT_FAIL](state) {
      return Object.assign({}, state, {
        client: {},
      });
    },
  },
);

export { billing as default };
